import App from "../../App";
import {DELETE_USER, LOGIN, UPDATE_USER} from "../Actions/user";

const savedState = App.storage.get('redux', {user: {}}).user || {};
const sessionId = App.session.get('sessionId', null) || App.rand(1000000000, 9999999999);

App.session.set('sessionId', sessionId);

const initialState = {
    permissions: [],
    ...savedState
};

const reducer = (state = initialState, action) => {
    let newState = {...state};

    switch (action.type) {
        case LOGIN:
            delete action.type;

            newState = {
                ...state,
                ...action,
                sessionId
            };
            break;
        case UPDATE_USER:
            delete action.type;

            newState = {
                ...state,
                ...action
            };
            break;
        case DELETE_USER:
            newState = {};
            break;

        default:
            return newState;
    }

    App.storage.set('redux', {
        ...App.storage.get('redux', {}),
        user: newState
    });

    return newState;
};

export default reducer